import { useEffect } from 'react';

const RobotsTxt = () => {
  useEffect(() => {
    // Set the content type to text/plain
    document.querySelector('meta[name="robots"]')?.setAttribute('content', 'noindex, nofollow');
  }, []);

  const robotsContent = `User-agent: *
Allow: /

# Sitemap
Sitemap: https://addictionrehabcall.com/sitemap.xml

# Important pages for crawling
Allow: /search
Allow: /states/
Allow: /facility/
Allow: /treatment-types
Allow: /insurance
Allow: /resources
Allow: /get-help

# Block admin areas
Disallow: /admin/
Disallow: /facility-dashboard
Disallow: /facility-login

# Block private/internal pages
Disallow: /api/`;

  return (
    <pre style={{ 
      fontFamily: 'monospace', 
      whiteSpace: 'pre-wrap', 
      margin: 0,
      padding: 0,
      fontSize: '12px'
    }}>
      {robotsContent}
    </pre>
  );
};

export default RobotsTxt;